import styled from "styled-components";

export const Wrapper = styled.footer`
  width: 100%;
  position: relative;
  bottom: 0;
  display: flex;
  background-color: ${({ theme }) =>
    theme.colors[theme.background.tertiary.color][
      theme.background.tertiary.intensity
    ]};
  background-color: #212529;
  justify-content: center;
  padding: 24px 0px;
  align-items: center;
`;
